<template>
  <div>
    <div class="leading-4 mt-3 mb-5 text-sm text-center text-gray-600">
      {{text}}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'authTitle',
    props: {
      text:String,
    },
    computed:{
    },
    methods:{
    }
  };
</script>

<style>

</style>